var map = {
	"./1.map.stories.tsx": "./src/stories/1.map.stories.tsx",
	"./2.common.stories.tsx": "./src/stories/2.common.stories.tsx",
	"./3.accordion.stories.tsx": "./src/stories/3.accordion.stories.tsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/stories sync ^\\.[\\\\/](?:(?%21\\.)(?=.)[^\\\\/]*?\\.stories\\.tsx)$";